export const isDesktop = (width: number, height: number) =>
	(width >= 1921 && height >= 1081) || (width >= 1080 && height >= 1920);
